(function () {
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function init() {
    var els = $$('.sh .reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else els.forEach(function (el) { el.classList.add('in'); });

    $$('.sh video').forEach(function (v) {
      v.muted = true; v.volume = 0;
      v.addEventListener('volumechange', function () { if (!v.muted || v.volume) { v.muted = true; v.volume = 0; } });
      if (v.autoplay) v.play().catch(function () {});
    });

    var lb = document.createElement('div');
    lb.className = 'sh-lightbox';
    lb.innerHTML = '<button class="close" aria-label="Close image">&times;</button><img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');
    function closeLB() { lb.classList.remove('on'); lbImg.classList.remove('zoomed'); }
    window.shOpenLightbox = function (src, alt) { lbImg.src = src; lbImg.alt = alt || ''; lb.classList.add('on'); };
    lbImg.onclick = function (e) { e.stopPropagation(); lbImg.classList.toggle('zoomed'); };
    lb.onclick = closeLB;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLB(); });
    $$('[data-zoom]').forEach(function (el) {
      el.addEventListener('click', function () { window.shOpenLightbox(el.currentSrc || el.src, el.alt); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();